export const EVENT_COLLAPSE_TOGGLE = 'fabric-collapse-toggle'
export const EVENT_COLLAPSE_EXPANDED = 'fabric-collapse-expanded'
export const EVENT_COLLAPSE_EXPANDING = 'fabric-collapse-expanding'
export const EVENT_COLLAPSE_COLLAPSED = 'fabric-collapse-collapsed'
export const EVENT_COLLAPSE_COLLAPSING = 'fabric-collapse-collapsing'
